import React from "react";

import Date from './props/Date';
import Description from './props/Description';
import Image from './props/Image';
import Link from './props/Link';
import Title from './props/Title';

const Vertical = ({
  date,
  description,
  image,
  link,
  properties,
  title
}) => {


  const isEnabled = name => !properties || properties.includes(name);

  const imageStyles = {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: '2px',
    height: '250px',
    width: '580px',
    display: 'inline-block'
  };

  return <div>
          {isEnabled('image') && <Image src={image} style={imageStyles}/>}
          {isEnabled('title') && <Title value={title}/>}
          {isEnabled('date') && <Date value={date}/>}
          {isEnabled('description') && <Description value={description}/>}
          {isEnabled('link') && <Link value={link}/>}
        </div>;
};

export default Vertical;
